/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Export_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Preset exported successfully" |
*
* @param {Preset_Manager_Export_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_export_success_toast = /** @type {((inputs?: Preset_Manager_Export_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Export_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Preset exporte avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreinstellung erfolgreich exportiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Predefinito esportato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительные настройки успешно экспортированы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preajuste exportado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预设已成功导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットが正常にエクスポートされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट सफलतापूर्वक निर्यात हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Predefinição exportada com sucesso.")
	return /** @type {LocalizedString} */ ("Preset exported successfully")
});